export const FETCH_PRODUCT_TYPES = 'FETCH_PRODUCT_TYPES'
